import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/constants";
import { trackPhoneClick } from "../../lib/gtag";

export default function FloatingCall() {
  return (
    <a
      data-testid="floating-call-button"
      href={PHONE_TEL}
      onClick={trackPhoneClick}
      aria-label={`Hívás Most: ${PHONE_DISPLAY}`}
      className="md:hidden fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#16A34A] hover:bg-[#15803d] text-white font-bold pl-4 pr-5 py-4 rounded-full shadow-2xl shadow-green-600/40 animate-pulse transition-colors"
    >
      <Phone className="w-6 h-6" />
      <span className="text-sm">Hívás</span>
    </a>
  );
}
